import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { type MarketBanner, marketService } from 'shared/src/api';

export const useMarketBanner = (marketId: number) => {
  return useQuery<MarketBanner[]>({
    queryKey: queryKey.marketBanner(marketId),
    queryFn: () =>
      marketService.getMarketBanner(marketId).then(result => {
        return result.banners;
      }),
  });
};
